export default __webpack_public_path__ + "static/media/life-science.710f5890.png";